fragment ApprovalsListFields on Approval {
  id
  __typename
  _urgencyLevel
  _rowTimestamp
  _isDeletable
  _createdDate
  name
  _fullApprovalDescription
  isAddApproversEligible
  isPrimary
  isNewApprovalSelectable
  isDelayedApproverAllowed
  approvalPhaseTypeId
  approvalPhaseType {
    id
    phaseName
  }
  approvalType {
    id
    approvalType
    layoutType
  }
  description
  priorityNumber
  abbreviation
  isDraft
  _statusTypeId
  statusType {
    statusType
    approvalState
    _transactionIconStatus
  }
  _isStagedApprovalRequest
}
